import Link from "next/link";
import useProductDetail from "@/app/lib/features/productDetail/productDetail.hook";
import { trackInteraction } from "@/app/lib/tracking/interactions";

const ProductDisclaimer = () => {
  const { product } = useProductDetail();

  if (!product?.store_info_group?.details || product.store_info_group.details.length === 0) {
    return null;
  }

  return (
    <ul className="list-disc ml-4 space-y-1 text-xs sm:text-sm my-4 marker:text-black">
      {product.store_info_group.details.map((detail, index) => (
        <li key={index} className="text-muted-foreground">
          {detail.includes("[]") ? (
            <>
              {detail.split("[]")[0]}
              <Link
                href={`/magaza/${product.store_info_group?.seller_slug}`}
                onClick={() => { if (product.store_info_group?.seller_id) trackInteraction("seller", product.store_info_group.seller_id, "click"); }}
                className="text-black underline font-medium"
              >
                {product.store_info_group?.seller_name}
              </Link>
              {detail.split("[]")[1]}
            </>
          ) : (
            detail
          )}
        </li>
      ))}
    </ul>
  );
};

export default ProductDisclaimer;
